import { render, staticRenderFns } from "./CategorySelectInputWidget.vue?vue&type=template&id=a0bd7a3a&scoped=true"
import script from "./CategorySelectInputWidget.vue?vue&type=script&lang=js"
export * from "./CategorySelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bd7a3a",
  null
  
)

export default component.exports